
import { ScaleLoader } from "react-spinners"
import "./index.css"

const Loader = ({NoEffect=true}) => {
    return (
        <div className={`loader-overlay ${!NoEffect ? "loader-back-effect" : ""}`}>
            <ScaleLoader  height={45} margin={2} radius={30} width={7} color="#7367f0" />
        </div>
    )
}
export default Loader